(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["steng-card-colors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('steng-card-colors')) {
    const ATTR = 'data-steng-color-value';

    /* The card's large <img> carries a responsive srcset built by Liquid. Rebuild the
       same set of widths against the newly selected colour's file so switching colour
       does not silently drop responsive images or downgrade quality. */
    const rebuildSrcset = (srcset, newBase) => {
      if (!srcset) return '';
      return srcset
        .split(',')
        .map((entry) => {
          const parts = entry.trim().split(/\s+/);
          const descriptor = parts[1] || '';
          const width = (parts[0].match(/[?&]width=(\d+)/) || [])[1];
          if (!width) return '';
          return newBase + '&width=' + width + (descriptor ? ' ' + descriptor : '');
        })
        .filter(Boolean)
        .join(', ');
    };

    const setVariantParam = (url, variantId) => {
      if (!url || !variantId) return url;
      const [path, query = ''] = url.split('?');
      const params = new URLSearchParams(query);
      params.set('variant', variantId);
      return path + '?' + params.toString();
    };

    customElements.define(
      'steng-card-colors',
      class extends HTMLElement {
        connectedCallback() {
          if (this.stengInitialized) return;
          this.labels = Array.from(this.querySelectorAll('[' + ATTR + ']'));
          if (!this.labels.length) return;
          this.stengInitialized = true;
          this.card = this.closest('product-card');
          this.group = this.labels[0].closest('fieldset');

          if (this.group) this.group.setAttribute('role', 'radiogroup');
          this.labels.forEach((label) => {
            label.setAttribute('role', 'radio');
            const selected = label.classList.contains('swatch-active');
            label.setAttribute('aria-checked', String(selected));
            label.tabIndex = selected ? 0 : -1;
            if (!label.getAttribute('aria-label')) {
              label.setAttribute('aria-label', label.dataset.stengColorValue || '');
            }
            if (label.dataset.stengColorAvailable === 'false') {
              label.setAttribute('aria-disabled', 'true');
            }
          });
          if (!this.labels.some((l) => l.tabIndex === 0)) this.labels[0].tabIndex = 0;

          this.addEventListener('click', this.onClick);
          this.addEventListener('keydown', this.onKeydown);
          this.watchAsyncPicker();
        }

        onClick(event) {
          const label = event.target.closest('[' + ATTR + ']');
          if (!label || !this.contains(label)) return;
          /* The swatch is a <label> with no control, so the default action is a no-op,
             but stop the event before the card's hover/quick-view listeners see it. */
          event.preventDefault();
          event.stopPropagation();
          this.select(label, { focus: false });
        }

        onKeydown(event) {
          const label = event.target.closest('[' + ATTR + ']');
          if (!label || !this.contains(label)) return;
          const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End', ' ', 'Enter'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          event.stopPropagation();

          if (event.key === ' ' || event.key === 'Enter') {
            this.select(label, { focus: true });
            return;
          }

          const i = this.labels.indexOf(label);
          const last = this.labels.length - 1;
          let next = i;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = i === last ? 0 : i + 1;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = i === 0 ? last : i - 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = last;
          this.select(this.labels[next], { focus: true });
        }

        /* Keyboard navigation can reach a swatch that the collapsed "+N more" state
           hides. Expand the group rather than moving focus to an invisible target. */
        ensureVisible(label) {
          if (label.offsetParent !== null) return;
          const toggle = this.querySelector('steng-card-swatches-toggle button');
          if (toggle && toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
        }

        select(label, { focus }) {
          const alreadySelected = label.classList.contains('swatch-active');
          this.ensureVisible(label);
          this.markSelected(label);
          if (focus) label.focus({ preventScroll: true });
          if (alreadySelected) return;
          this.updateImage(label.dataset.stengColorImage);
          this.updateLinks(label.dataset.stengColorVariant);
          this.syncAsyncPicker(label.dataset.stengColorValue);
        }

        markSelected(label) {
          this.labels.forEach((other) => {
            const selected = other === label;
            other.classList.toggle('swatch-active', selected);
            other.setAttribute('aria-checked', String(selected));
            other.tabIndex = selected ? 0 : -1;
          });
          const readout = this.querySelector('[data-option-value]');
          if (readout) readout.textContent = label.dataset.stengColorValue || '';
        }

        updateImage(url) {
          if (!url || !this.card) return;
          const anchor = this.card.querySelector('.prd-image');
          if (!anchor) return;
          const images = Array.from(anchor.querySelectorAll(':scope > img.js-prd-img'));
          if (!images.length) return;

          /* The card renders a second image for the rollover effect. It belongs to
             whichever colour was shown at render time, so keep exactly one image after
             a colour change: hovering must never bring back another colour. */
          images.slice(1).forEach((img) => img.remove());
          this.card.querySelector('.prd-image-clone')?.remove();

          const img = images[0];
          const base = url.split('&width=')[0];
          const srcset = rebuildSrcset(img.getAttribute('srcset') || img.getAttribute('data-srcset'), base);
          const width = (img.getAttribute('src') || '').match(/[?&]width=(\d+)/);
          const src = base + (width ? '&width=' + width[1] : '');

          /* lazysizes re-applies data-src/data-srcset on resize, so update both the
             live attributes and the lazy ones or the old colour would come back. */
          img.setAttribute('src', src);
          img.setAttribute('data-src', src);
          if (srcset) {
            img.setAttribute('srcset', srcset);
            img.setAttribute('data-srcset', srcset);
          } else {
            img.removeAttribute('srcset');
            img.removeAttribute('data-srcset');
          }
          img.classList.remove('lazyload');
          img.classList.add('lazyloaded');
        }

        updateLinks(variantId) {
          if (!variantId || !this.card) return;
          this.dataset.initVariant = variantId;
          this.card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
            link.setAttribute('href', setVariantParam(link.getAttribute('href'), variantId));
          });
          if (this.card.dataset.ajax) {
            this.card.dataset.ajax = setVariantParam(this.card.dataset.ajax, variantId);
          }
          this.card.querySelectorAll('[data-ajax]').forEach((node) => {
            if (node !== this.card && node.dataset.ajax.includes('/products/')) {
              node.dataset.ajax = setVariantParam(node.dataset.ajax, variantId);
            }
          });
          const wishlist = this.card.querySelector('wishlist-button[data-variant-id]');
          if (wishlist) wishlist.dataset.variantId = variantId;
        }

        /* The card lazy-loads the full picker (with real radios) into .ajax-container.
           Keep the two in agreement in both directions without re-dispatching change
           events, so neither picker can drive the other into a loop. */
        colorFieldset(picker) {
          const order = this.dataset.colorOptionOrder;
          return order == null
            ? picker.querySelector('fieldset')
            : picker.querySelector('fieldset[data-lvl="' + order + '"]');
        }

        syncAsyncPicker(value) {
          if (!this.card || value == null) return;
          this.card.querySelectorAll('variant-radios').forEach((picker) => {
            const fieldset = this.colorFieldset(picker);
            if (!fieldset) return;
            fieldset.querySelectorAll('label').forEach((label) => {
              const input = label.querySelector('input[type="radio"]');
              const match = input ? input.value === value : label.dataset.stengColorValue === value;
              label.classList.toggle('swatch-active', match);
              if (input) input.checked = match;
            });
            /* The "Color: X" readout above the swatches is normally written by the theme's
               onVariantChange, which never runs for a picker that cannot resolve a variant.
               Without this it keeps naming the colour the card was rendered with. */
            const readout = fieldset.closest('.prd-option')?.querySelector('[data-option-value]');
            if (readout) readout.textContent = value;
          });
        }

        selectedValue() {
          const active = this.labels.find((l) => l.classList.contains('swatch-active'));
          return active ? active.dataset.stengColorValue : null;
        }

        watchAsyncPicker() {
          if (!this.card || this.card.stengCardColorsWatched) return;
          this.card.stengCardColorsWatched = true;

          /* The card lazy-loads its full picker on hover or on mobile. If that arrives
             after a colour was picked here it renders the colour that was current when the
             request was issued, leaving two swatches looking selected and the "Color: X"
             readout naming the wrong one. Re-apply the current selection when it appears.
             Observe the card itself, not `.ajax-container`: the theme replaces that
             container rather than filling it, so an observer on the container never fires.
             The theme can also re-request the picker on resize, so keep watching and key
             off the picker node identity instead of disconnecting. */
          let syncedPicker = null;
          new MutationObserver(() => {
            const picker = this.card.querySelector('variant-radios');
            if (!picker || picker === syncedPicker) return;
            syncedPicker = picker;
            const value = this.selectedValue();
            if (value) this.syncAsyncPicker(value);
          }).observe(this.card, { childList: true, subtree: true });

          /* The card's full picker exposes only the colour option even though the product
             has more (it hides size), and the theme resolves a variant by matching every
             option, so its `currentVariant` comes back undefined and onVariantChange
             silently does nothing: no image change, no link change. Where that mismatch
             exists, drive the change from here instead. Pickers that do expose every
             option are left entirely to the theme. */
          this.card.addEventListener('click', (event) => {
            const label = event.target.closest?.('[' + ATTR + ']');
            if (!label || this.contains(label)) return;
            const picker = label.closest('variant-radios');
            if (!picker) return;
            const exposed = picker.querySelectorAll('fieldset').length;
            const total = parseInt(picker.dataset.lvls || '0', 10);
            if (total <= exposed) return;
            const mine = this.labels.find(
              (l) => l.dataset.stengColorValue === label.dataset.stengColorValue
            );
            if (mine) this.select(mine, { focus: false });
          });

          this.card.addEventListener('change', (event) => {
            const input = event.target.closest?.('input[type="radio"]');
            if (!input) return;
            const picker = input.closest('variant-radios');
            if (!picker || picker.contains(this)) return;
            if (this.colorFieldset(picker) !== input.closest('fieldset')) return;
            const label = this.labels.find((l) => l.dataset.stengColorValue === input.value);
            /* The full picker already updated the image via the theme's own code path,
               so only mirror the selection state here. */
            if (label) this.markSelected(label);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["steng-card-swatches-toggle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('steng-card-swatches-toggle')) {
    let swatchGroupId = 0;

    customElements.define('steng-card-swatches-toggle', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const button = this.querySelector('button');
        const group = this.closest('fieldset');
        if (!button || !group) return;
        this.initialized = true;
        if (!group.id) group.id = 'steng-card-colors-' + (++swatchGroupId);
        button.setAttribute('aria-controls', group.id);
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          group.dataset.stengExpanded = String(expanded);
          button.setAttribute('aria-expanded', String(expanded));
          button.setAttribute('aria-label', expanded ? button.dataset.collapseLabel : button.dataset.expandLabel);
          if (!expanded) {
            const bounds = button.getBoundingClientRect();
            if (bounds.top < 0 || bounds.bottom > window.innerHeight) {
              button.scrollIntoView({ block: 'nearest', behavior: 'instant' });
            }
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
